<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-4">
                    		    <label >Código Empresa </label>
                    		    <input type="text" v-model="material.Codigo" class="form-control" placeholder="Código Empresa" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Codigo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Código Fabricante </label>
                    		    <input type="text" v-model="material.CodigoFabricante" class="form-control" placeholder="Código Fabricante" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoFabricante" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-4">
                    		    <label >Ítem </label>
								<div class="position-relative">
									<input type="text" v-model="material.Item" class="form-control" placeholder="Ítem" @input="onInput" @blur="hideSuggestions" @focus="onFocus"/>
									<ul v-if="ShowList && ItemFiltrado.length" class="suggestions">
										<li v-for="(item,index) in ItemFiltrado" :key="index" @mousedown.prevent="selectSuggestion(item)">
											{{item}}
										</li>
									</ul>
								</div>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label for="">Unidad</label>
								<div class="position-relative">
									<input type="text" class="form-control" v-model="material.Unidad" placeholder="Unidad" @input="onInputUnidad" @blur="hideSuggestionsUnidad" @focus="onFocusUnidad">
									<ul v-show="ShowListUnidad && UnidadFiltrado.length" class="suggestions">
										<li v-for="(item,index) in UnidadFiltrado" :key="index" @mousedown.prevent="selectSuggestionUnidad(item)">
											{{item}}
										</li>
									</ul>
								</div>
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Marca</label>
								<input type="text" class="form-control" v-model="material.Marca" placeholder="Marca">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="this.errorvalidacion.Marca[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
								<label>Modelo</label>
								<input type="text" class="form-control" v-model="material.Modelo" placeholder="Modelo">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="this.errorvalidacion.Modelo[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                    		    <label >Costo Unitario</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="material.Precio"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Precio" :Mensaje="this.errorvalidacion.Precio[1]"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-2">
								<label for="">Stock</label>
								<input @input="CambiarFechaStock" type="number" class="form-control" v-model="material.Stock" placeholder="Stock">
								<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
							</div>
							<div class="col-lg-3">
                    		    <label for="">Fecha Stock</label>
                    		    <v-date-picker v-model="material.FechaStock" :mode="typeCalendar"
                    		        :popover="{
                    		            placement: 'bottom',
                    		            visibility: 'click'
                    		        }"
                    		        :input-props="{
                    		            class: 'form-control cal-black',
                    		            style: 'cursor:pointer;'
                    		        }"
                    		        :locale="'es-MX'"
                    		    >
									<template v-slot="{ inputValue, inputEvents }">
										<input type="text" disabled="true" :value="inputValue" class="form-control calendar" style="cursor:pointer;background-color:#F9F9F9"
                    		        	v-on="inputEvents">
									</template>
								</v-date-picker>
                    		</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="row">
							<div class="col-lg-12">
								<div class="avatar-upload almacen-upload">
									<div class="avatar-edit">
										<input
											id="file"
											ref="file"
											type="file"
											name="myfile"
											@change="uploadImage()"
											accept=".png, .jpg, .jpeg"
										/>
										<label for="file"></label>
									</div>
									<div class="avatar-preview imagenes-almacen">
										<div
											id="imagePreview"
											style="background-image: url(Img);"
										></div>
									</div>
								</div>
								<label class="ml-5 pl-3 mt-2">Recomendada 400 x 400</label>
							</div>
						</div>
					</div>
                    <!--fin col-6-->
                </div>
				<div class="row mt-3">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea v-model="material.NomMaterial" maxlength="70" cols="30" rows="1" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
				<div class="mt-3" v-if="material.IdMaterial>0">
					<ListForm :ShowButtonTop="DatosTablaProveedor.ShowButtonTop"
					:ShowButton="true"
					:NombreTabla="DatosTablaProveedor.NombreTabla"
					:EmitSeccionTabla="DatosTablaProveedor.EmitSeccionTabla"
                    :TituloBoton="DatosTablaProveedor.TituloBoton"
                    :pConfigLoad="DatosTablaProveedor.ConfigLoad"
					:pShowPager="true">
						<template slot="header_table_form">
							<th>Proveedor</th>
							<th>N° Parte Proveedor</th>
							<th>Precio de Lista</th>
							<th>Última Cotización</th>
							<th>Nombre Contacto</th>
							<th>Tipo de Contacto</th>
							<th>Acciones</th>
						</template>
						<template slot="body_table_form">
							<tr v-for="(item,index) in Proveedores" :key="index">
								<td>{{item.Proveedor}}</td>
								<td>{{item.NoParteProveedor}}</td>
								<td>$ {{Number(item.Precio).toLocaleString('es-MX') }}</td>
								<td class="p-0"><i class="fa fa-calendar"></i> {{$getCleanDate(item.UltimaCotizacion,false)}}</td>
								<td>{{item.NombreContacto}}</td>
								<td>{{item.TipoContacto}}</td>
								<td colspan="2"><Cbtnaccion :isModal="true" 
                                    :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla" 
                                    :Id="item.IdMaterialProveedor"
                                    :IrA="DatosTablaProveedor.TituloBoton">

									</Cbtnaccion>
								</td>
							</tr>
						</template>
					</ListForm>
				</div>
                <!--Fin body del panel-->
            </template>
        </CLoader>
		<Modal 
            :NameModal="DatosTablaProveedor.TituloBoton" 
            :size="'modal-lg'" 
            :Nombre="DatosTablaProveedor.TituloBoton" 
            :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla"
            :poBtnSave="DatosTablaProveedor.oBtnSave"
        >
            <template slot="Form">
                <FormProveedores :poBtnSave="DatosTablaProveedor.oBtnSave" :IdMaterial="material.IdMaterial"></FormProveedores>
            </template>
        </Modal>
    </div>
     
</template>
<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import ListForm from '@/components/Clistform.vue';
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import Modal from '@/components/Cmodal.vue';
import FormProveedores from '../materiales/proveedores/Form.vue';
import $$ from "jquery";

export default {
    name:'Form',
    props:['NameList','poBtnSave'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'tipounidad',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            material:{            
                IdMaterial:0,
                Codigo:"S/N",
                NomMaterial:"",
                Precio:"",
				Item:"",
				Unidad:"",
				Stock:0,
				FechaStock:"",
				Marca:"",
				Modelo:"",
				CodigoFabricante:"",
				Imagen:""
            },
			Imagen:"",
			FechaStockOriginal:"",
			StockOriginal:"",
            urlApi:"cotizacion_material/recovery",
            errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			ItemsMaterial:[],
			ShowList:false,
			ItemsUnidad:[],
			ShowListUnidad:false,
			DatosTablaProveedor:{
				ConfigLoad:{
                    ShowLoader:true,
                    ClassLoad:true
                },
				ShowButtonTop:false,
                ShowButton:true,
				NombreTabla:"Proveedores",
				EmitSeccionTabla:"Proveedores",
				TituloBoton:"Proveedores",
				oBtnSave:{
                	isModal:true,
                	disableBtn:false,
                	toast:0,
                	nombreModal:"Proveedores",
                	EmitSeccion:"Proveedores"
            	},
				Filtros:{
					TotalItem:0,
                	Pagina:1,
                	Entrada:5,
				}
			},
			Proveedores:[]
        }
    },
    components:{
        Cbtnsave,
        Clist,Cvalidation,Modal,ListForm,FormProveedores,Cbtnaccion
    },
    methods :
    {
    
       async Guardar()
        {
             //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('IdMaterial',this.material.IdMaterial);
			formData.set('NomMaterial',this.material.NomMaterial);
			formData.set('Precio',this.material.Precio);
			formData.set('Codigo',this.material.Codigo);
			formData.set('Unidad',this.material.Unidad);
			formData.set('Stock',this.material.Stock);
			formData.set('Item',this.material.Item);
			formData.set('FechaStock',this.material.FechaStock);
			formData.set('Marca',this.material.Marca);
			formData.set('Modelo',this.material.Modelo);
			formData.set('Imagen',this.material.Imagen);
			formData.set('CodigoFabricante',this.material.CodigoFabricante);
			let file = this.$refs.file.files[0];
			formData.append("ImagenFile", file);
            await this.$http.post(
                'cotizacion_material/post',
                formData,
				{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                },
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion); 

            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  

            });
       
        },
         Limpiar()
        {
            this.material.IdMaterial=0;
            this.material.NomMaterial="";
            this.material.Codigo="S/N";
            this.material.Precio="";
			this.material.Item="";
			this.material.Unidad="";
			this.material.Marca="";
			this.material.Modelo="";
			this.material.Stock=0;
			this.material.FechaStock='';
			this.material.CodigoFabricante='';
			this.material.Imagen='';
			this.StockOriginal=0;
			this.FechaStockOriginal=new Date();
            this.errorvalidacion=[];
			this.Imagen="";
			const input = this.$refs.file;
			input.type = 'text'
            input.type = 'file';
			this.readURL(this.Imagen);
            
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdMaterial: this.material.IdMaterial}
                }
            ).then( (res) => {
                this.material=res.data.data.material;
				let Foto=res.data.data.material.Imagen;
				if (Foto != "" && Foto != null) {
					this.Imagen = res.data.data.ruta + this.material.Imagen;
				}
				this.readURL(this.Imagen);
				if (res.data.data.material.FechaStock!=null) {
					let formatedDate = res.data.data.material.FechaStock.replace(/-/g, "\/");
                	this.material.FechaStock=new Date(formatedDate)
					this.FechaStockOriginal=new Date(formatedDate);	
				}
				else{
					this.material.FechaStock=new Date();
					this.FechaStockOriginal=new Date();
				}
				this.StockOriginal=res.data.data.material.Stock;
				this.GetMaterialProveedor();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		async GetMaterialProveedor(){
			this.DatosTablaProveedor.ConfigLoad.ShowLoader=true;
			await this.$http.get('materialproveedor/get',{
                params:{
                    IdMaterial:this.material.IdMaterial,
					Entrada:this.DatosTablaProveedor.Filtros.Entrada,
					pag:this.DatosTablaProveedor.Filtros.Pagina
                }
            }).then((res)=>{
                this.Proveedores=res.data.data.materialproveedor;
				this.DatosTablaProveedor.Filtros.Entrada=res.data.data.pagination.PageSize;
				this.DatosTablaProveedor.Filtros.TotalItem=res.data.data.pagination.TotalItems;
                // this.UrlDocumentos=res.data.data.urlarchivos;
            }).finally(()=>{
                this.DatosTablaProveedor.ConfigLoad.ShowLoader=false;
            })
		},
		BorrarProveedor(Id){
			this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'materialproveedor/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.GetMaterialProveedor();
                    })
                }
            })
		},
		CambiarFechaStock(){
			if (this.material.Stock!=this.StockOriginal) {
				this.material.FechaStock=new Date();
			}
			else{
				this.material.FechaStock=this.FechaStockOriginal;
			}
		},
		ListItem(){
			this.$http.get('cotizacion_material_item/get').then((res)=>{
				this.ItemsMaterial=res.data.data.row;
			})
		},
		ListUnidad(){
			this.$http.get('cotizacion_material_unidad/get').then((res)=>{
				this.ItemsUnidad=res.data.data.row;
			})
		},
		onInput() {
    	  	this.ShowList = true;
    	},
    	selectSuggestion(item) {
    	  	this.material.Item = item;
    	  	this.ShowList = false;
    	},
		hideSuggestions() {
     		 // Delay to allow click event on suggestion to trigger before hiding
     		 setTimeout(() => {
     		   this.ShowList = false;
     		 }, 100);
    	},
		onFocus() {
      		if (this.material.Item) {
        		this.ShowList = true;
      		}
    	},
		onInputUnidad() {
    	  	this.ShowListUnidad = true;
    	},
    	selectSuggestionUnidad(item) {
			// console.log(item);
    	  	this.material.Unidad = item;
    	  	this.ShowListUnidad = false;
    	},
		hideSuggestionsUnidad() {
     		 // Delay to allow click event on suggestion to trigger before hiding
     		 setTimeout(() => {
     		   this.ShowListUnidad = false;
     		 }, 100);
    	},
		onFocusUnidad() {
      		if (this.material.Unidad) {
        		this.Unidad = true;
      		}
    	},
		uploadImage() {
			this.material.Imagen = this.$refs.file.files[0];
			const image = this.$refs.file.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Imagen = e.target.result;
				this.readURL(this.Imagen);
			};
		},
		readURL(input) {
			$$("#imagePreview").css("background-image", "url(" + this.Imagen + ")");
			$$("#imagePreview").hide();
			$$("#imagePreview").fadeIn(650);
		},
    },
    created() {
        
        this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   
			this.ListItem();
			this.ListUnidad();
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.material.IdMaterial=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });

		this.bus.$off("List_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("List_"+this.DatosTablaProveedor.EmitSeccionTabla,()=>{
            this.GetMaterialProveedor();
        });
		this.bus.$off("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla,(Id)=>{
            this.BorrarProveedor(Id);
        });
       
    },
	computed:{
        typeCalendar:function(){
            return 'single';
        },
		ItemFiltrado(){
			// console.log(this);
			if (this.ItemsMaterial.length>0) {
				const input = this.material.Item.toLowerCase();
      			return this.ItemsMaterial.filter((item) =>
      			  item.toLowerCase().includes(input)
      			);	
			}
		},
		UnidadFiltrado(){
			// console.log(this);
			if (this.ItemsUnidad.length>0) {
				const input = this.material.Unidad.toLowerCase();
      			return this.ItemsUnidad.filter((item) =>
      			  item.toLowerCase().includes(input)
      			);	
			}
		}
    }
}
</script>
